export default __webpack_public_path__ + "static/media/Motilal Building.4b69f6bf.svg";